import TopBarMenuComponent from "./TopBarMenuComponent";

export default TopBarMenuComponent;
